'use strict';
var parent = require('../../actual/object/get-own-property-names');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/get-own-property-names.js
// module id = 635
// module chunks = 13